const IFRAME_TOKEN_KEY = 'skyla_iframe_token';
const MILLISECONDS_PER_SECOND = 1000;
/**
 * Detects if the app is running inside an iFrame (e.g., embedded in WebUntis).
 * Uses window.self !== window.top check. In cross-origin contexts where accessing
 * window.top throws a DOMException, we catch the error and return true.
 */
export const isInIframe = () => {
    try {
        return window.self !== window.top;
    }
    catch {
        // Cross-origin restriction = we're in an iFrame
        return true;
    }
};
/**
 * Gets the stored iframe JWT token from partitioned localStorage.
 * Modern browsers partition localStorage in cross-origin iFrames using the key scheme
 * (top-level-site, iframe-origin), ensuring token isolation between contexts.
 * Returns null if not in an iFrame or no token stored.
 */
export const getIframeToken = () => {
    if (!isInIframe())
        return null;
    return localStorage.getItem(IFRAME_TOKEN_KEY);
};
/**
 * Stores the iframe JWT token in partitioned localStorage.
 * The token persists across iFrame reloads on the same top-level domain,
 * enabling seamless re-authentication (only 1× login per 12h session).
 */
export const setIframeToken = (token) => {
    localStorage.setItem(IFRAME_TOKEN_KEY, token);
};
/**
 * Checks if a valid (non-expired) iframe token exists.
 * Decodes the JWT payload to check the `exp` claim without a library.
 */
export const isIframeTokenValid = () => {
    const token = getIframeToken();
    if (!token)
        return false;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.exp * MILLISECONDS_PER_SECOND > Date.now();
    }
    catch {
        return false;
    }
};
/**
 * Removes the iframe token from localStorage.
 */
export const clearIframeToken = () => {
    localStorage.removeItem(IFRAME_TOKEN_KEY);
};
